import { jwtDecode } from "jwt-decode";
import AuthService from "../../services/AuthService";
import { hasLocalAccess } from "../../lib/configs";
import { PermissionName } from "../../lib/types";
import { AccessToken } from "../../lib/types/AccessToken";

// Привилегии, которых еще нет в базе, но нужно получить доступ к разделу в ходе разработки
const excludedPermissions: PermissionName[] = [];

const checkExcludedPermissions = (permissions: PermissionName[]): boolean => {
  return permissions.some((permission) => excludedPermissions.includes(permission));
};

const currentUser = AuthService.getCurrentUser();
const authorities = currentUser ? jwtDecode<AccessToken>(currentUser).authorities : undefined;

export const hasAccess = (...permissions: PermissionName[]): boolean => {
  if (!hasLocalAccess("feature.roles") || !authorities) {
    return false;
  }
  if (checkExcludedPermissions(permissions)) {
    return true;
  }
  return authorities.some((item) => permissions.includes(item));
};
